"use strict";
const moment = require('moment');


class Calendar {
    
    constructor(momentObj){

        if (moment(momentObj).isValid()) {
            this.moment = moment(momentObj);
            this._year = this.moment.get('year');
            this._month = this.moment.get('month');
        }else{
            throw new Error("Date Picker - Invalid Constructor Object - should be moment object format.");
        }

        // set to the beginning of the month;
        this.moment.date(1);
    }

    createDay(mmnt) {
        let dayMoment = {
            moment: moment(mmnt),
            month: mmnt.month(),
            date: mmnt.date(),
            day: mmnt.day(),
            year: mmnt.year()
        };
        dayMoment.selectable = (dayMoment.month === this._month);
        return dayMoment;
    }

    generate(opts) {
        let m; // reused variable for moment()
        let w; // reused variable as a "week"

        // defaults
        opts = opts || {};
        if (opts.withOtherMonthDays === undefined) {
            opts.withOtherMonthDays = true;
        }

        // we will fill in this array
        let weeks = [];

        w = [];
        m = moment(this.moment);
        let daysInMonth = this.moment.daysInMonth();
        let d = 1;
        while (d <= daysInMonth) {
            // finish and close off the week
            if (m.day() === 0 && w.length) {
                weeks.push(w);
                w = [];
            }

            // add the day to the week
            w.push(this.createDay(m));

            // advance one day
            m.add(1, 'days');
            d++;
        }

        // add the last week
        if (w.length) {
            weeks.push(w);
        }

        // we will associate other days to the first
        // and last weeks if applicable.
        if (opts.withOtherMonthDays) {
            w = weeks[0];
            m = moment(this.moment).subtract(1, 'days');
            while (w.length < 7) {
                w.unshift(this.createDay(m));
                m.subtract(1, 'days');
            }
            weeks[0] = w;

            w = weeks[weeks.length - 1];
            m = moment(this.moment).add(1, 'months');
            while (w.length < 7) {
                w.push(this.createDay(m));
                m.add(1, 'day');
            }
            weeks[weeks.length - 1] = w;
        }

        return weeks;
    }
}

module.exports = Calendar;

